/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupsDto as DigiworkMaitreDPosDtoGroupGroupsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/groups-dto';

export interface GetGroupLayouts$Params {
  venueId?: string;
}

export function getGroupLayouts(http: HttpClient, rootUrl: string, params?: GetGroupLayouts$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>> {
  const rb = new RequestBuilder(rootUrl, getGroupLayouts.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>;
    })
  );
}

getGroupLayouts.PATH = '/api/groups/layouts';
